{
  "decrease": "Reducir {fieldLabel}",
  "increase": "Aumentar {fieldLabel}",
  "numberField": "Campo de número"
}
